import { render, staticRenderFns } from "./ProfiletwoComponent.vue?vue&type=template&id=6d12328a&"
import script from "./ProfiletwoComponent.vue?vue&type=script&lang=js&"
export * from "./ProfiletwoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfiletwoComponent.vue?vue&type=style&index=0&id=6d12328a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports